import { Form, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import axiosInstance from "../../../utils/axios";
import IndexPageForm from "../../../component/indexPageForm";

export default function IndexManageDetail() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({});
  const params = useParams();
  const id = params?.id;
  const [cookies, setCookie, removeCookie] = useCookies(['admin']);

  const fetchIndex = async () => {
    await axiosInstance.get(`/index-page/getByIndexPageId/${params?.id}`)
      .then((res) => {
        const data = res?.data?.data[0];
        const values = {
          ...data,
        };
        setInitialValues(values);
      });
  };

  const onSubmit = async (values) => {
    try {
      if (id && id !== "tao-moi") {
        await axiosInstance.post(`/index-page/updateIndexPage/${id}`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
          });
      } else {
        await axiosInstance.post(`/index-page/createIndexPage`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
          });
      }
      navigate("/admin/quan-ly-trang-chu");
    } catch (error) {
      message.error(error);
    }
  };

  useEffect(() => {
    if (id && id !== "tao-moi") fetchIndex();
    form.resetFields();
  }, [form, id]);

  return (
    <IndexPageForm
      id={id !== "create" ? id : undefined}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  );
}
